module.exports = __webpack_public_path__ + "static/media/LOW.0d62f29e.png";